import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { ExpandButton } from '../../../../../components/ExpandButton/index.js';
import { Container } from '../../../../../components/Newsletter/LayerContent/components/Conditions/components/Container.js';
import { useBooleanToggle } from '../../../../../hooks/useBooleanToggle/useBooleanToggle.js';
import { CollapsibleContent, List, ListItem } from '../../../../../primitives/index.js';
export const Conditions = /*#__PURE__*/_styled(({
  ...restProps
}) => {
  const {
    t
  } = useTranslation('newsletterVoucher');
  const list = t('legal.list', {
    returnObjects: true
  });
  const [isExpanded, handleExpand] = useBooleanToggle();
  return _jsx(Container, {
    ...restProps,
    children: _jsx(CollapsibleContent, {
      hiddenContent: _jsx(List, {
        spacing: "none",
        children: list.map((value, i) => _jsx(ListItem, {
          children: value
        }, i))
      }),
      expanded: isExpanded,
      controls: _jsx(ExpandButton, {
        onClick: handleExpand,
        isExpanded: isExpanded,
        translations: {
          showLess: t('legal.hideConditions'),
          showMore: t('legal.showConditions')
        }
      })
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1769xyp0"
} : {
  target: "e1769xyp0",
  label: "Conditions"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCRyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB1c2VUcmFuc2xhdGlvbiB9IGZyb20gJ25leHQtaTE4bmV4dCc7XG5pbXBvcnQgeyBFeHBhbmRCdXR0b24gfSBmcm9tICcuLi8uLi8uLi8uLi8uLi9jb21wb25lbnRzL0V4cGFuZEJ1dHRvbi9pbmRleC5qcyc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi8uLi8uLi9jb21wb25lbnRzL05ld3NsZXR0ZXIvTGF5ZXJDb250ZW50L2NvbXBvbmVudHMvQ29uZGl0aW9ucy9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyB1c2VCb29sZWFuVG9nZ2xlIH0gZnJvbSAnLi4vLi4vLi4vLi4vLi4vaG9va3MvdXNlQm9vbGVhblRvZ2dsZS91c2VCb29sZWFuVG9nZ2xlLmpzJztcbmltcG9ydCB7IENvbGxhcHNpYmxlQ29udGVudCwgTGlzdCwgTGlzdEl0ZW0gfSBmcm9tICcuLi8uLi8uLi8uLi8uLi9wcmltaXRpdmVzL2luZGV4LmpzJztcbmV4cG9ydCBjb25zdCBDb25kaXRpb25zID0gc3R5bGVkKCh7IC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgY29uc3QgeyB0IH0gPSB1c2VUcmFuc2xhdGlvbignbmV3c2xldHRlclZvdWNoZXInKTtcbiAgICBjb25zdCBsaXN0ID0gdCgnbGVnYWwubGlzdCcsIHtcbiAgICAgICAgcmV0dXJuT2JqZWN0czogdHJ1ZSxcbiAgICB9KTtcbiAgICBjb25zdCBbaXNFeHBhbmRlZCwgaGFuZGxlRXhwYW5kXSA9IHVzZUJvb2xlYW5Ub2dnbGUoKTtcbiAgICByZXR1cm4gKF9qc3goQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgY2hpbGRyZW46IF9qc3goQ29sbGFwc2libGVDb250ZW50LCB7IGhpZGRlbkNvbnRlbnQ6IF9qc3goTGlzdCwgeyBzcGFjaW5nOiBcIm5vbmVcIiwgY2hpbGRyZW46IGxpc3QubWFwKCh2YWx1ZSwgaSkgPT4gKF9qc3goTGlzdEl0ZW0sIHsgY2hpbGRyZW46IHZhbHVlIH0sIGkpKSkgfSksIGV4cGFuZGVkOiBpc0V4cGFuZGVkLCBjb250cm9sczogX2pzeChFeHBhbmRCdXR0b24sIHsgb25DbGljazogaGFuZGxlRXhwYW5kLCBpc0V4cGFuZGVkOiBpc0V4cGFuZGVkLCB0cmFuc2xhdGlvbnM6IHtcbiAgICAgICAgICAgICAgICAgICAgc2hvd0xlc3M6IHQoJ2xlZ2FsLmhpZGVDb25kaXRpb25zJyksXG4gICAgICAgICAgICAgICAgICAgIHNob3dNb3JlOiB0KCdsZWdhbC5zaG93Q29uZGl0aW9ucycpLFxuICAgICAgICAgICAgICAgIH0gfSkgfSkgfSkpO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1pbmRleC5qcy5tYXAiXX0= */");